import { render } from "./AccordionEditor.vue?vue&type=template&id=324c451c&scoped=true"
import script from "./AccordionEditor.vue?vue&type=script&lang=js"
export * from "./AccordionEditor.vue?vue&type=script&lang=js"

import "./AccordionEditor.vue?vue&type=style&index=0&id=324c451c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324c451c"]])

export default __exports__